export default "/imgs/icon_down.png"